import React, {useEffect, useState} from 'react';
import HLIconButton from "../../shared/components/icon-button/HLIconButton";
import ArrowBackIcon from "../../shared/styles/icons/ArrowBackIcon";
import classes from "./LessonPage.module.scss";
import {useNavigate, useParams} from "react-router-dom";
import {useAppSelector} from "../../shared/hooks/useAppSelector";
import {LessonStructureResponse, LessonStudentStructureResponse} from "../../shared/types/lesson";
import {loadLessonStructureByIdFetch} from "../../app/axios/lessonFetches";
import {TeacherRole} from "../../shared/types/teacher";
import HLInfoRow, {HLInfoRowSizeType, HLInfoRowStyleType} from "../../shared/components/info-row/HLInfoRow";
import {formatDateTimeForString} from "../../shared/utils/dateUtils";
import HLButton from "../../shared/components/button/HLButton";
import UpdateLessonModal from "../../modal/lesson/UpdateLessonModal";

const LessonPage = () => {
    const {id, agreementId} = useParams();
    const {currentTeacher} = useAppSelector(state => state.auth);
    const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false);

    const [lesson, setLesson] = useState<LessonStructureResponse | null>(null);
    const navigate = useNavigate();

    useEffect(() => {
        if (id) loadLessonStructure()
    }, [id]);

    const loadLessonStructure = () => loadLessonStructureByIdFetch(Number(id)).then(setLesson)

    const getStudentValue = (student: LessonStudentStructureResponse) => {
        const lessonPrice = currentTeacher?.role === TeacherRole.ADMIN ? `(${student.lessonPrice} ₽)` : '';
        return `${student.firstName} ${student.lastName || ''} ${lessonPrice}`;
    }

    const onBack = () => navigate(`/agreements/${agreementId}`);

    const handleUpdate = () => setIsUpdateModalOpen(true)

    return (
        <>
            <div className="pageContainer">
                <div className="columnContainer">
                    <HLIconButton
                        icon={<ArrowBackIcon/>}
                        onClick={onBack}
                        aria-label="Назад к договорам"
                    />

                    {
                        lesson &&
                        <div className={`${classes.contentContainer} columnContainer`}>
                            <h2>Урок</h2>
                            <div className="inlineContainer">
                                <div className={classes.infoContainer}>
                                    <h3 className={classes.formTitle}>Общая информация</h3>

                                    <HLInfoRow label="Дата урока:" value={formatDateTimeForString(lesson.lessonDate)}/>
                                    <HLInfoRow label="Проведен:"
                                               value={lesson.conducted ? 'Да' : 'Нет'}
                                               styleType={lesson.conducted ? HLInfoRowStyleType.SUCCESS : HLInfoRowStyleType.ERROR}
                                    />
                                </div>

                                <div className={classes.infoContainer}>
                                    <h3 className={classes.formTitle}>Учитель</h3>

                                    <HLInfoRow
                                        value={`${lesson.teacher.firstName} ${lesson.teacher.lastName} (${lesson.teacher.teacherRate} ₽)`}/>
                                </div>

                                <div className={classes.infoContainer}>
                                    <h3 className={classes.formTitle}>Ученики</h3>

                                    {
                                        lesson.students.map(student =>
                                            <>
                                                <HLInfoRow value={getStudentValue(student)}/>
                                                <HLInfoRow label="Присутствовал:"
                                                           value={student.attended ? 'Да' : 'Нет'}
                                                           styleType={student.attended ? HLInfoRowStyleType.SUCCESS : HLInfoRowStyleType.ERROR}
                                                           sizeType={HLInfoRowSizeType.SMALL}
                                                />
                                                <HLInfoRow label="Списан:"
                                                           value={student.paid ? 'Да' : 'Нет'}
                                                           styleType={student.paid ? HLInfoRowStyleType.SUCCESS : HLInfoRowStyleType.ERROR}
                                                           sizeType={HLInfoRowSizeType.SMALL}
                                                />
                                            </>
                                        )
                                    }
                                </div>
                            </div>
                            <HLButton onClick={handleUpdate}>
                                Изменить
                            </HLButton>
                        </div>
                    }
                </div>
            </div>
            <UpdateLessonModal
                open={isUpdateModalOpen}
                setOpen={setIsUpdateModalOpen}
                lesson={lesson}
                loadLesson={loadLessonStructure}
            />
        </>
    );
};

export default LessonPage;